// Corrected EditNotifications
// Added submit button inside the form
import React from "react";

const EditNotifications = ({ notifications = {}, onChange, onSubmit }) => {
  // Define notification fields with parent-child relationships
  const notificationGroups = [
    {
      label: "Cases Created",
      field: "casesCreatedByAccount",
      subItems: [
        { label: "Cases Created, by the Account", field: "casesCreatedByAccount" },
        { label: "Cases Created, by the Lab", field: "casesCreatedByLab" },
      ],
    },
    {
      label: "Cases Changed",
      field: "casesChangedByAccount",
      subItems: [
        { label: "Account Changed, by the Account", field: "accountChangedByAccount" },
        { label: "Account Changed, by the Lab", field: "accountChangedByLab" },
      ],
    },
    { label: "Pickup Requests", field: "pickupRequests" },
    { label: "Balance Payments", field: "balancePayments" },
    { label: "Invoices", field: "invoices" },
    { label: "Processes", field: "processes" },
    { label: "Accounts", field: "accounts" },
    { label: "Accounts Changed, by the Lab", field: "accountsChangedByLab" },
  ];

  // Extract webNotifications from props with a fallback
  const { webNotifications = {} } = notifications;

  // Handle checkbox changes
  const handleChange = (field, checked) => {
    const updatedNotifications = {
      ...notifications,
      webNotifications: {
        ...webNotifications,
        [field]: checked,
      },
    };
    onChange(updatedNotifications);
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      webNotifications,
    });
  };

  return (
    <div style={{ width: "120%",maxWidth:"1800px", margin: "0 auto", padding: "0px" }}>
      <div className="row">
        <div className="col-md-10">
          <h1>Web Notifications</h1>
          <form onSubmit={handleSubmit}>
            <div
              className="Web Notification"
              style={{
                   border: "1px solid #f8f9fa",
                  borderTop: "3px solid #004aad",
                  backgroundColor: "#e9ecef",
                  padding:"20px"
              }}
            >
              <h4>Labnext Activity Log</h4>
              <div className="checks" style={{ marginLeft: "20%" }}>
                {notificationGroups.map((group, index) => (
                  <div key={index}>
                    {/* Render parent item */}
                    <label>
                      <input
                        type="checkbox"
                        name={group.label}
                        checked={webNotifications[group.field] || false}
                        onChange={(e) => handleChange(group.field, e.target.checked)}
                        style={{ marginRight: "10px" }}
                      />
                      {group.label}
                    </label>
                    <br />
                    {/* Render sub-items if they exist */}
                    {group.subItems && group.subItems.length > 0 && (
                      <div style={{ marginLeft: "20px" }}>
                        {group.subItems.map((subItem, subIndex) => (
                          <div key={subIndex}>
                            <label>
                              <input
                                type="checkbox"
                                name={subItem.label}
                                checked={webNotifications[subItem.field] || false}
                                onChange={(e) => handleChange(subItem.field, e.target.checked)}
                                style={{ marginRight: "10px" }}
                              />
                              {subItem.label}
                            </label>
                            <br />
                          </div>
                        ))}
                      </div>
                    )}
                    <br />
                  </div>
                ))}
              </div>
            </div>
            <div style={{ textAlign: "right", marginTop: "10px" }}>
              <button 
                type="submit" 
                style={{ backgroundColor: "#004aad", color: "#fff", border: 'none', padding: "8px 16px", borderRadius: "4px" }}
              >
                Save Notifications
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditNotifications;